<template>
  <div class="RulesetSourcefieldModal">
    <div
      class="modal fade"
      id="sourceFieldModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sourceFieldModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content" style="min-height: inherit;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Source Field Manager
            </h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row g-3 d-flex">
              <div class="col-sm-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search by field name or description..."
                  v-model="searchQuery"
                  v-on:keyup="debounceInput"
                />
              </div>
              <div class="col-sm-2" style="align-self: center;">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="inlineCheckbox1"
                    value="Quotey"
                    v-model="typeFilter"
                    v-on:click="debounceInput"
                  />
                  <label class="form-check-label" for="inlineCheckbox1">
                    Quotey
                  </label>
                </div>
              </div>
              <div class="col-sm-2" style="align-self: center;">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="inlineCheckbox1"
                    value="Calculated"
                    v-model="typeFilter"
                    v-on:click="debounceInput"
                  />
                  <label class="form-check-label" for="inlineCheckbox1">
                    Calculated
                  </label>
                </div>
              </div>
              <div class="col-sm-2" style="text-align: center;">
                <button
                  type="button"
                  class="btn"
                  style="padding: 0 0;"
                  @click="clearSearch"
                >
                  <font-awesome-icon icon="fa-regular fa-circle-xmark" />
                </button>
              </div>
            </div>
            <Paginator
              :key="paginatorKey"
              :position="'modal'"
              :array="resultQuery"
              :numberOfFields="resultQuery.length"
              :activePageNumberTemp="activePageNumber"
              :loadPerPageTemp="loadPerPage"
              :pageStart="pageStart"
              :numberOfPages="Math.ceil(resultQuery.length / loadPerPage)"
              :reverseSortTemp="reverseSort"
              :parentWidth="1050"
              perPageType="sourcefieldmanager"
              @goToPage="goToPage"
              @itemsPerPageUpdated="itemsPerPageUpdated"
              @updateReverseSort="updateReverseSort"
            ></Paginator>
            <div v-if="sourceLoader" class="spinner-border text-primary" />
            <div v-else-if="!resultQuery.length"></div>
            <div v-else class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Field Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="field in filteredSourcefields"
                    :key="field.source_fields_id"
                  >
                    <td>
                      <div>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="newSelectedSourceFields"
                          v-bind:value="field.field_name"
                          :key="field.field_name"
                        />
                      </div>
                    </td>
                    <td>{{ field.field_name }}</td>
                    <td>{{ field.description }}</td>
                    <td>{{ field.origin_type }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="selectFunction()"
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from "../../Paginator.vue";
import jQuery from "jquery";
import _ from "lodash";

export default {
  name: "RulesetSourcefieldModal",
  props: {
    sourcefields: Array,
    sourceLoader: Boolean,
    loadPerPageTemp: Number,
  },
  components: { Paginator },
  emits: ["renderFields"],
  data() {
    return {
      searchQuery: "",
      typeFilter: "",
      resultQuery: [],
      // From EditRuleset
      newSelectedSourceFields: [],
      // For Paginator
      pageStart: 0,
      loadPerPage: this.loadPerPageTemp,
      activePageNumber: 1,
      reverseSort: "false",
      paginatorKey: 0,
      reversed: false,
    };
  },
  watch: {
    sourcefields() {
      this.resultQuery = this.filterMap();
      this.paginatorKey += 1;
    },
    loadPerPageTemp() {
      this.loadPerPage = this.loadPerPageTemp;
    },
    reverseSort() {
      this.checkReverseRulesFiltered();
    },
  },
  computed: {
    filteredSourcefields() {
      // Returns the list to be displayed
      return this.resultQuery.slice(
        this.pageStart,
        this.pageStart + this.loadPerPage
      );
    },
  },
  methods: {
    // Runs every time rules/rulesFiltered is reset OR when reverseSort is changed from the paginator component
    checkReverseRulesFiltered() {
      // reverseSort is what the sorting needs to be (string)
      // reversed is what the array currently is (boolean)
      if (this.reverseSort === "true" && !this.reversed) {
        this.resultQuery.reverse();
        this.reversed = true;
      } else if (this.reverseSort == "false" && this.reversed) {
        this.resultQuery.reverse();
        this.reversed = false;
      }
    },
    resetSelectedSourceFields: function() {
      this.newSelectedSourceFields = [];
    },
    selectFunction() {
      this.close();
      this.$emit("renderFields", this.newSelectedSourceFields);
    },

    // From LoadModal
    open: function(sourceFields) {
      this.resetModal();
      this.newSelectedSourceFields = sourceFields;
      jQuery("#sourceFieldModal").modal("show");
    },
    close: function() {
      jQuery("#sourceFieldModal").modal("toggle");
    },
    // From EditRuleset
    goToPage(newActivePageNumber, newPageStart) {
      this.activePageNumber = newActivePageNumber;
      this.pageStart = newPageStart;
    },
    itemsPerPageUpdated(newActivePageNumber, newPageStart, newLoadPerPage) {
      this.activePageNumber = newActivePageNumber;
      this.pageStart = newPageStart;
      this.loadPerPage = newLoadPerPage;
    },
    updateReverseSort(newReverseSort) {
      this.reverseSort = newReverseSort;
    },
    resetModal() {
      this.pageStart = 0;
      this.loadPerPage = this.loadPerPageTemp;
      this.activePageNumber = 1;
      this.reverseSort = "false";
      this.reversed = false;
      this.clearSearch();
    },
    clearSearch() {
      this.searchQuery = "";
      this.typeFilter = "";
      this.resultQuery = this.filterMap();
    },
    debounceInput: _.debounce(function(e) {
      console.log("called debounceInput on", e.target.value);
      this.resultQuery = this.filterMap();
    }, 500),
    filterMap() {
      if (this.searchQuery || this.typeFilter) {
        this.pageStart = 0;
        this.activePageNumber = 1;
        return this.sourcefields.filter((field) => {
          return (
            (this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => field.field_name.toLowerCase().includes(v)) ||
              // this.searchQuery
              //   .toLowerCase()
              //   .split(" ")
              //   .every((v) => field.field_name.includes(v)) ||
              this.searchQuery
                .toLowerCase()
                .split(" ")
                .every((v) =>
                  (field.description ? field.description : "")
                    .toLowerCase()
                    .includes(v)
                )) &&
            this.typeFilter
              .split(" ")
              .every((v) => field.origin_type.includes(v))
          );
        });
      } else {
        return this.sourcefields;
      }
    },
  },
};
</script>

<style scoped>
.modal-lg {
  min-width: min(1300px, 90%);
}
.table-responsive {
  max-height: 300px;
  height: 400px;
}
.spinner-border {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}
</style>
